import * as React from 'react'
import { StyleSheet, View } from 'react-native'
import { Spacer } from '@components/Spacer'
import * as Colors from '@themes/Colors'
import { StoryCard } from '../StoryCard'
import { ViewMore } from './ViewMore'
import type { StoriesScrollViewProps } from './types'

const GUTTER = 16
const WIDTH = 257

export function StoriesScrollView(props: StoriesScrollViewProps) {
  return (
    <View style={styles.app}>
      <View style={[styles.container, styles.appChildFull]}>
        <Spacer noShrink width={GUTTER} />
        {props.data?.map((story, index) => (
          <View
            style={styles.item}
            key={story.id ? `story_${story.id}` : index}
          >
            {props.isPlaceholderData || props.isLoading ? (
              <StoryCard.Loading />
            ) : (
              <StoryCard {...story} />
            )}
          </View>
        ))}

        <View style={styles.viewMore}>
          <ViewMore />
        </View>

        <Spacer noShrink width={GUTTER} />
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  app: {
    paddingVertical: GUTTER,
    paddingHorizontal: 0,
    display: 'grid',
    gridGap: `${GUTTER}px 0`,
    gridTemplateColumns: `${GUTTER}px 1fr ${GUTTER}px`,
    alignContent: 'flex-start',
    flex: 1,
    overflowX: 'scroll',
  },
  appChildFull: {
    gridColumn: '1 / -1',
    scrollbarWidth: 'none',
    marginBottom: 0,
  },
  container: {
    display: 'grid',
    gridGap: `calc(${GUTTER}px / 2)`,
    gridTemplateColumns: '10px',
    gridTemplateRows: 'minmax(150px, 1fr)',
    gridAutoFlow: 'column',
    scrollSnapType: 'x proximity',
    paddingBottom: 8,
  },
  item: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
    backgroundColor: Colors.white,
    borderRadius: 8,
    width: WIDTH,
    marginRight: 8,
  },
  viewMore: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
    width: WIDTH * 2,
    height: '100%',
    backgroundColor: Colors.backgroundGray,
    borderRadius: 8,
  },
})
